import { bootstrapConstants } from "./Constants";
import { bootstrapService } from "./Service";
import { alertActions } from "../alert/Actions";

export const bootstrapActions = {
  measurements
};

export function measurements() {
  return dispatch => {
    dispatch(request({}));
    const promises = [];
    promises.push(bootstrapService.measurementcategory());
    promises.push(bootstrapService.measurementtype());
    promises.push(bootstrapService.measurementmagnitude());
    Promise.all(promises).then(
      measurements => {
        dispatch(success(measurements));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: bootstrapConstants.MEASUREMENTS_REQUEST };
  }
  function success(measurements) {
    return {
      type: bootstrapConstants.MEASUREMENTS_SUCCESS,
      measurements
    };
  }
  function failure(error) {
    return { type: bootstrapConstants.MEASUREMENTS_FAILURE, error };
  }
}
